import RequestAbstract from "../abstract";

export default class PublicProxies extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/public-proxies";
    }

}
